import {
  apiClient,
  handleResponse,
} from './axios';

async function updateElearningDetails(elearningId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/${elearningId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateElearningDetailsWithNotification(elearningId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/notif/${elearningId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateSubGroupUsers(elearningId, subgroupId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/subgroup/user/${elearningId}/${subgroupId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

async function updateSubGroup(elearningId, body) {
  try {
    const response = await apiClient
      .put(`/elearningdetails/subgroup/${elearningId}`, body);
    const groups = await handleResponse(response);
    return groups;
  } catch (error) {
    return error.response;
  }
}

const elearningServices = {
  updateElearningDetails,
  updateSubGroupUsers,
  updateSubGroup,
  updateElearningDetailsWithNotification,
};

export default elearningServices;
